import { ContentItem } from 'kentico-cloud-delivery';
import { get } from 'lodash';

export default class Link extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get id() {
    return this.system.id;
  }

  get title() {
    return get(this, '_tytul.value');
  }

  get url() {
    return get(this, '_adres_url.value');
  }

  get isBlank() {
    return get(this, '_blank.value[0].name');
  }
}



// WEBPACK FOOTER //
// ./src/models/Link.model.js